import React from "react";

const stages = [
  { code: "STAGE 01", title: "Audit", text: "Senior engineers walk your environment. Systems, contracts, gaps. Output: a written audit your team can use after we leave." },
  { code: "STAGE 02", title: "Architect", text: "Target architecture, sequencing, cost model and a written risk register at the level your board can defend." },
  { code: "STAGE 03", title: "Ship", text: "Short, demoable releases. Documented, monitored and reviewed against contracted SLAs from sprint one." },
  { code: "STAGE 04", title: "Operate", text: "Managed services, quarterly business reviews, continuous improvement — and a clean handover whenever you want one." }
];

const Approach = () => (
  <div className="approach">
    {stages.map((s) => (
      <div key={s.code} className="step">
        <span className="dot" />
        <div className="code">{s.code}</div>
        <h4>{s.title}</h4>
        <p>{s.text}</p>
      </div>
    ))}
  </div>
);

export default Approach;
